<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'SecondaryUsers' })"
  >
    <form
      class="modal-card"
      @submit.prevent="update"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Edición de usuario
        </p>
      </header>
      <section class="modal-card-body">
        <SecondaryUser
          v-if="loaded"
          :loading="loading"
        />
        <BLoading
          :is-full-page="false"
          :active.sync="loading"
        />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'SecondaryUsers' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Guardar
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'SecondaryEdit',

  components: {
    SecondaryUser: () => import(/* webpackChunkName: "new-employee" */ '@/components/Admin/SecondaryUser/NewSecondaryUser.vue'),
  },

  data() {
    return {
      loaded: false,
      loading: false,
    };
  },

  async beforeMount() {
    this.loading = true;
    await this.$store.dispatch('users/getSingleSecondary', this.$route.params.secondaryId);
    this.loading = false;
    this.loaded = true;
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit('users/setValues', {
      name: '',
      email: '',
    });

    next();
  },

  methods: {
    async update(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('users/updateSecondary', this.$route.params.secondaryId);
        this.$success({ message: 'El usario se actualizó exitosamente' });
        this.$router.push({ name: 'SecondaryUsers' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}
</style>
